import React, { useState } from "react";
import { Shield } from 'lucide-react';
import { Link } from "react-router-dom";
import { useRepGuardExtension } from "./useRepGuardExtension";
import { PATHS } from "../../../constants/Paths";

const DISMISS_STORAGE_KEY = "repcheck_repguard_prompt_dismissed";
const DISMISS_DAYS = 7;

function getDismissedUntil() {
  try {
    const raw = localStorage.getItem(DISMISS_STORAGE_KEY);
    return raw ? parseInt(raw, 10) : 0;
  } catch {
    return 0;
  }
}

function setDismissedUntil() {
  try {
    const until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(DISMISS_STORAGE_KEY, String(until));
  } catch {
    // ignore
  }
}

export default function RepGuardInstallPrompt() {
  const installed = useRepGuardExtension();
  const [dismissed, setDismissed] = useState(false);

  const dismissedUntil = getDismissedUntil();
  const isDismissedByStorage = dismissedUntil > Date.now();

  const show = !installed && !dismissed && !isDismissedByStorage;

  const handleDismiss = () => {
    setDismissed(true);
    setDismissedUntil();
  };

  if (!show) return null;

  return (
    <div
      className="flex items-center justify-between gap-4 px-4 py-3 bg-amber-50 border-b border-amber-200 text-amber-900 dark:bg-amber-500/10 dark:border-amber-500/30 dark:text-amber-200"
      role="banner"
    >
      <div className="flex items-center gap-3 min-w-0">
        <span className="flex-shrink-0 text-lg" aria-hidden>
          <Shield className="h-5 w-5" aria-hidden />
        </span>
        <p className="text-sm font-medium truncate">
          Install the <strong>RepGuard</strong> extension to check drafts before posting on X.
        </p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <Link
          to={PATHS.REPGUARD_INSTALL}
          className="px-3 py-1.5 text-sm font-medium rounded-md bg-amber-600 text-white hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1"
        >
          How to install
        </Link>
        <button
          type="button"
          onClick={handleDismiss}
          className="px-3 py-1.5 text-sm font-medium text-amber-800 hover:text-amber-900 hover:bg-amber-100 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1 dark:bg-amber-500/15 dark:text-amber-300"
          aria-label="Dismiss for 7 days"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
